import { render, staticRenderFns } from "./CustomerExtends.vue?vue&type=template&id=61c6029a"
import script from "./CustomerExtends.vue?vue&type=script&lang=js"
export * from "./CustomerExtends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports